/**
 * Creates a cross browser event constructor
 * 
 * @param eventName The name of the event we want to create
 */
export function newEvent(eventName: string): Event {
    let event;
    if (typeof(Event) === 'function') {
        event = new Event(eventName);
    } else {
        event = document.createEvent('Event');
        event.initEvent(eventName, true, true);
    }
    return event;
}
